/**
 * Chokbox Storefront Interactivity
 * Portion variant selector, narrative tabs, particle bursts, and AJAX cart.
 */

// 1. Interactive Portion / Weight Variant Selection
function selectPortion(variantId, formattedPrice, btnElement) {
  const container = btnElement.closest('.product-purchase-area') || document;
  const buttons = container.querySelectorAll('.portion-btn');
  buttons.forEach(btn => btn.classList.remove('active'));
  btnElement.classList.add('active');

  // Update hidden input for form submission
  const input = container.querySelector('#SelectedVariantId');
  if (input) input.value = variantId;

  // Update price display with pop animation
  const priceDisplay = container.querySelector('.product-price-value');
  if (priceDisplay) {
    priceDisplay.textContent = formattedPrice;
    priceDisplay.classList.add('pop');
    setTimeout(() => priceDisplay.classList.remove('pop'), 300);
  }
}

// 2. Interactive Wonka Tri-Narrative Story Switcher
function switchStory(paneId, tabElement) {
  const container = tabElement.closest('.narrative-container') || document;
  const tabs = container.querySelectorAll('.narrative-tab');
  tabs.forEach(t => t.classList.remove('active'));
  tabElement.classList.add('active');

  const panes = container.querySelectorAll('.story-pane');
  panes.forEach(p => p.classList.remove('active'));

  const target = document.getElementById(paneId);
  if (target) target.classList.add('active');
}

// 3. Golden Ticket Confetti Particle Burst
function triggerGoldenSparkles(event) {
  const btn = event.currentTarget;
  const rect = btn.getBoundingClientRect();
  const originX = rect.left + rect.width / 2;
  const originY = rect.top + rect.height / 2;

  for (let i = 0; i < 30; i++) {
    const spark = document.createElement('div');
    spark.className = 'golden-sparkle-particle';
    spark.style.cssText = `
      position: fixed;
      left: ${originX}px;
      top: ${originY}px;
      width: ${Math.random() * 8 + 4}px;
      height: ${Math.random() * 8 + 4}px;
      background: ${Math.random() > 0.5 ? '#f3d18e' : '#e43226'};
      border-radius: 50%;
      pointer-events: none;
      z-index: 99999;
      transform: translate(-50%, -50%);
      box-shadow: 0 0 10px #f3d18e;
      transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
    `;
    document.body.appendChild(spark);

    const angle = Math.random() * Math.PI * 2;
    const distance = Math.random() * 120 + 40;
    const destX = Math.cos(angle) * distance;
    const destY = Math.sin(angle) * distance;

    requestAnimationFrame(() => {
      spark.style.transform = `translate(calc(-50% + ${destX}px), calc(-50% + ${destY}px)) scale(0)`;
      spark.style.opacity = '0';
    });

    setTimeout(() => spark.remove(), 800);
  }
}

// 4. AJAX Cart Submission
document.addEventListener('DOMContentLoaded', () => {
  const addToCartForms = document.querySelectorAll('form[action$="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span>✨</span> Packing Your Bag...';
      }

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (response.ok) {
          triggerGoldenSparkles(e);
          // Fetch updated cart count
          const cartRes = await fetch('/cart.js');
          if (cartRes.ok) {
            const cart = await cartRes.json();
            const counter = document.querySelector('.tasting-bag-count');
            if (counter) counter.textContent = `Tasting Bag (${cart.item_count})`;
          }
          if (btn) btn.innerHTML = '<span>✦</span> Added to Bag!';
          setTimeout(() => {
            if (btn) {
              btn.disabled = false;
              btn.innerHTML = originalText;
            }
          }, 2000);
        } else {
          form.submit(); // fallback to native submission
        }
      } catch (err) {
        form.submit();
      }
    });
  });
});
